<template>
  <header>
    <div class="media">
      <div class="media-left ml-2 mr-4">
        <img
          :src="activeApp.icon"
          :alt="activeApp.name"
          width="50"
        >
      </div>
      <div class="media-body">
        <h1 class="h3 mb-1">
          {{ activeApp.name }}
        </h1>
        <div class="h5 text-muted font-weight-normal mb-3">
          {{ activeApp.short_description }}
        </div>
        <div>
          <button
            v-if="!activeApp.required"
            class="btn btn-primary"
            @click="updateLibrary(activeApp)"
            @mouseover="displayText('mouseover')"
            @mouseout="displayText('mouseout')"
            :class="{
              'btn-light muted': activeApp.displayAsInstalled && activeApp.isInstalled,
              'btn-light': !activeApp.displayAsInstalled && activeApp.isInstalled,
              'btn-primary': !activeApp.isInstalled
            }"
          >
            <span class="text-uppercase" v-if="!activeApp.loading">
              <i
                v-if="activeApp.isInstalled"
                class="fa"
                :class="{ 'fa-minus': !activeApp.displayAsInstalled}"
              ></i>

              <i
                v-else
                class="fa fa-plus"
              ></i>
              <span class="ml-1"> {{ activeApp.displayText }} </span>
            </span>
            <span v-else>
              <i class="fa fa-fw fa-circle-o-notch fa-spin"></i>
            </span>
          </button>

          <a
            v-if="activeApp.isInstalled"
            class="btn btn-primary ml-1 text-uppercase"
            target="_blank"
            :href="urls.sso.login(activeApp)"
          >
            <i class="fa fa-fw fa-sign-in mr-1"></i>
            Sign In
          </a>

          <a
            :href="activeApp.guide_url"
            class="btn btn-link"
            target="_blank"
            v-if="activeApp.guide_url"
          >
            Read Getting Started Guide
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

import { updateMyApps } from '@/api'
import urls from '@/api/urls'
import alertify from "alertify.js";

export default {
  props: {
    app: Object
  },

  data () {
    return {
      activeApp: {},
      urls,
    }
  },

  mounted() {
    this.activeApp = this.app;
    //this.app.displayAsInstalled = this.app.isInstalled
  },

  methods: {
    updateLibrary(activeApp) {
      if(activeApp.required) {
        alertify.alert(`Sorry, ${activeApp.name} cannot be uninstalled!`);
        return;
      }
      let confirmText = this.activeApp.isInstalled ? 'remove' : 'install'
      alertify.confirm(`Are you sure you want to ${confirmText} ${activeApp.name}?`, () => {
        //this.app = {...app}
        this.activeApp.loading = true;
        let action = this.activeApp.isInstalled ? 'detach' : 'attach'
        updateMyApps([this.activeApp], action)
            .then(result => {
              this.activeApp.loading = false
              this.activeApp.isInstalled = !this.activeApp.isInstalled
              this.activeApp.displayAsInstalled = this.activeApp.isInstalled;
              this.activeApp.displayText = this.activeApp.isInstalled ? 'INSTALLED' : 'ADD'
            })
      })
    },

    displayText(action) {
      if(activeApp.required) return;
      if(action === 'mouseover') {
        this.activeApp.displayAsInstalled = !this.activeApp.displayAsInstalled;
        if(this.activeApp.isInstalled) {
          this.activeApp.displayText = 'REMOVE'
        } else {
          this.activeApp.displayText = 'ADD'
        }
      } else if(action === 'mouseout') {
        this.activeApp.displayAsInstalled = !this.activeApp.displayAsInstalled;
        if(this.activeApp.isInstalled) {
          this.activeApp.displayText = 'INSTALLED'
        } else {
          this.activeApp.displayText = 'ADD'
        }
      }
    }

  }

}

</script>
